import { useGlobalState } from "../globalState/GlobalStateProvider";
import { BiUserCircle } from "@react-icons/all-files/bi/BiUserCircle";
import { BiChevronDown } from "@react-icons/all-files/bi/BiChevronDown";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ContextMenu from "./ContextMenu";
import Divider from "./Divider";

const AZUL = "rgb(24, 52, 98)";

type MenuItemProps = {
  icon: string;
  label: string;
  onClick: () => void;
  danger?: boolean;
};

const MenuItem = ({ icon, label, onClick, danger }: MenuItemProps) => (
  <button
    onClick={onClick}
    style={{
      display: "flex",
      alignItems: "center",
      gap: "12px",
      width: "100%",
      padding: "12px 16px",
      background: "transparent",
      border: "none",
      cursor: "pointer",
      fontSize: "14px",
      color: danger ? "#d32f2f" : "#333",
      textAlign: "left",
      transition: "background-color 0.15s ease",
    }}
    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f5f5f5")}
    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
  >
    <i className={icon} style={{ fontSize: "18px", color: danger ? "#d32f2f" : AZUL }} />
    <span>{label}</span>
  </button>
);

const TopbarUserInfo = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state } = useGlobalState();

  const abbr = () => {
    if (!state.user?.nomeUsuario) return "";

    const splited = state.user?.nomeUsuario.split(" ") || [];
    const first = splited[0];
    const last = splited[splited.length - 1];

    return `${first.substring(0, 1)}${last.substring(0, 1)}`.toUpperCase();
  };

  const handleLogout = () => {
    localStorage.removeItem("localState");
    window.location.href = "/creditbureau/login";
  };

  return (
    <div>
      <ContextMenu
        buttonProps={{
          variant: "ghost",
          style: {
            boxShadow: "none",
            color: "white",
            background: "transparent",
            border: "none",
            paddingLeft: 0,
            paddingRight: 0,
            marginRight: "16px",
            display: "flex",
            "&:hover": { background: "transparent", boxShadow: "none" },
          },
        }}
        buttonLabel={
          <>
            {state.user?.nomeUsuario || ""}{" "}
            <BiUserCircle
              style={{ marginLeft: "8px", marginRight: "8px", marginTop: "-3px", fontSize: "20px" }}
            />{" "}
            <BiChevronDown style={{ fontSize: "20px", marginTop: "-3px" }} />
          </>
        }
        cardProps={{ style: { padding: 0 } }}
      >
        <div
          style={{
            position: "absolute",
            right: "0px",
            top: "56px",
            minWidth: "280px",
            padding: "0px",
            border: "1px solid #e0e0e0",
            backgroundColor: "white",
            boxSizing: "border-box",
            borderRadius: "8px",
            boxShadow: "0 4px 16px rgba(0, 0, 0, 0.12)",
            overflow: "hidden",
          }}
        >
          {/* Cabeçalho com avatar + nome */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              padding: "16px",
              backgroundColor: AZUL,
              color: "white",
            }}
          >
            <span
              style={{
                background: "rgba(255, 255, 255, 0.2)",
                borderRadius: "50%",
                width: "48px",
                height: "48px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "bold",
                fontSize: "16px",
                flexShrink: 0,
              }}
            >
              {abbr()}
            </span>
            <span style={{ fontWeight: 600, fontSize: "14px", lineHeight: "1.3" }}>
              {state.user?.nomeUsuario || ""}
            </span>
          </div>

          <div style={{ padding: "8px 0" }}>
            <MenuItem
              icon="pi pi-key"
              label={t("alterarSenha")}
              onClick={() => navigate("/alterarsenha")}
            />
            <MenuItem
              icon="pi pi-shield"
              label={t("autenticacaoDoisFatores")}
              onClick={() => navigate("/autenticacao-dois-fatores")}
            />
          </div>

          <Divider style={{ margin: 0 }} />

          <div style={{ padding: "8px 0" }}>
            <MenuItem icon="pi pi-sign-out" label={t("logout")} onClick={handleLogout} danger />
          </div>
        </div>
      </ContextMenu>
    </div>
  );
};

export default TopbarUserInfo;
